import { pickPersonaLine } from "./pickPersonaLine";
import type { ResultsPersonaId } from "./personaIds";

export type PersonaVoice = {
	pollIntro: (question: string) => string;
	voteButton: string;
	closeButton: string;
	statusButton: string;
	remindHostButton: string;
	remindHostSuccess: string;
	remindCalm: (question: string) => string;
	remindSoon: (question: string, hoursLeft: number) => string;
	remindLastCall: (question: string, hoursLeft: number) => string;
	voteModalTitle: string;
	voteModalIntro: (question: string) => string;
	voteSubmit: string;
	createModalTitle: string;
	createSubmit: string;
	gatherThreadIntro: (question: string) => string;
};

/** Resolve persona copy for a stable seed (typically roomId). */
export function personaVoice(personaId: ResultsPersonaId, seed = ""): PersonaVoice {
	const pick = (kind: Parameters<typeof pickPersonaLine>[1], ctx: { question?: string; hoursLeft?: number } = {}) =>
		pickPersonaLine(personaId, kind, seed, ctx);

	return {
		pollIntro: (question) => pick("pollIntro", { question }),
		voteButton: pick("voteButton"),
		closeButton: pick("closeButton"),
		statusButton: pick("statusButton"),
		remindHostButton: pick("remindHostButton"),
		remindHostSuccess: pick("remindHostSuccess"),
		remindCalm: (question) => pick("remindCalm", { question }),
		remindSoon: (question, hoursLeft) => pick("remindSoon", { question, hoursLeft }),
		remindLastCall: (question, hoursLeft) => pick("remindLastCall", { question, hoursLeft }),
		voteModalTitle: pick("voteModalTitle"),
		voteModalIntro: (question) => pick("voteModalIntro", { question }),
		voteSubmit: pick("voteSubmit"),
		createModalTitle: pick("createModalTitle"),
		createSubmit: pick("createSubmit"),
		gatherThreadIntro: (question) => pick("gatherThreadIntro", { question }),
	};
}
